const ChartColors = [
    "#B750BE",
    "#41ADFC",
    "#f2994a",
    "#C89BE0",
    "#70F0AE",
    "#ED589D",
    "#E39263",
    "#29C384",
    "#DBE9BE",
    "#16D1D2",
    "#DBA7C1",
    "#3CA3CF",
    "#7EDB83",
    "#5CFD88",
    "#EB9562",
    "#CED0A1",
    "#70BFA5",
    "#9B95FD",
    "#5596C4",
    "#B8F7D1",
];

export default ChartColors;
